export default function workerFunction() {
    this.onmessage = async function (e) {
        this.postMessage("perform api call");
    };
}

